/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormDto,
  ApplicationFormVersionDto,
  ApplicationFormVersionListItemDto,
  ProblemDetails,
  WorksAgreementComparisonDto,
  WorksAgreementProblemDto,
} from '../models/index';
import {
    ApplicationFormDtoFromJSON,
    ApplicationFormDtoToJSON,
    ApplicationFormVersionDtoFromJSON,
    ApplicationFormVersionDtoToJSON,
    ApplicationFormVersionListItemDtoFromJSON,
    ApplicationFormVersionListItemDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    WorksAgreementComparisonDtoFromJSON,
    WorksAgreementComparisonDtoToJSON,
    WorksAgreementProblemDtoFromJSON,
    WorksAgreementProblemDtoToJSON,
} from '../models/index';

export interface CreateApplicationFormVersionRequest {
    id: string;
}

export interface GetApplicationFormVersionRequest {
    id: string;
    versionNumber: number;
}

export interface GetApplicationFormVersionsRequest {
    id: string;
}

export interface GetSignedPdfRequest {
    id: string;
    versionNumber: number;
}

export interface GetWorksAgreementComparisonRequest {
    applicationFormId: string;
    versionNumber: number;
}

export interface GetWorksAgreementHtmlRequest {
    applicationFormId: string;
    versionNumber: number;
}

export interface GetWorksAgreementPdfRequest {
    applicationFormId: string;
    versionNumber: number;
}

export interface RestoreApplicationFormVersionRequest {
    id: string;
    versionNumber: number;
}

/**
 * 
 */
export class ApplicationFormVersionApi extends runtime.BaseAPI {

    /**
     * Create a new draft version from the current signed version
     */
    async createApplicationFormVersionRaw(requestParameters: CreateApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createApplicationFormVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/versions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Create a new draft version from the current signed version
     */
    async createApplicationFormVersion(requestParameters: CreateApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.createApplicationFormVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get specific version with full snapshot
     */
    async getApplicationFormVersionRaw(requestParameters: GetApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormVersionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormVersion().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getApplicationFormVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/versions/{versionNumber}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormVersionDtoFromJSON(jsonValue));
    }

    /**
     * Get specific version with full snapshot
     */
    async getApplicationFormVersion(requestParameters: GetApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormVersionDto> {
        const response = await this.getApplicationFormVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all versions of an application form
     */
    async getApplicationFormVersionsRaw(requestParameters: GetApplicationFormVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationFormVersionListItemDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormVersions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/versions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationFormVersionListItemDtoFromJSON));
    }

    /**
     * Get all versions of an application form
     */
    async getApplicationFormVersions(requestParameters: GetApplicationFormVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationFormVersionListItemDto>> {
        const response = await this.getApplicationFormVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download the signed PDF for a specific version
     */
    async getSignedPdfRaw(requestParameters: GetSignedPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSignedPdf().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getSignedPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/versions/{versionNumber}/signed-pdf`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download the signed PDF for a specific version
     */
    async getSignedPdf(requestParameters: GetSignedPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getSignedPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Compares the resolved provision model (not the rendered text) per paragraph and per annex.
     * Compares the works agreement of a form version with the last signed version below it
     */
    async getWorksAgreementComparisonRaw(requestParameters: GetWorksAgreementComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorksAgreementComparisonDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getWorksAgreementComparison().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getWorksAgreementComparison().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/versions/{versionNumber}/works-agreement-comparison`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorksAgreementComparisonDtoFromJSON(jsonValue));
    }

    /**
     * Compares the resolved provision model (not the rendered text) per paragraph and per annex.
     * Compares the works agreement of a form version with the last signed version below it
     */
    async getWorksAgreementComparison(requestParameters: GetWorksAgreementComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorksAgreementComparisonDto> {
        const response = await this.getWorksAgreementComparisonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates an HTML preview of the works agreement for a form version
     */
    async getWorksAgreementHtmlRaw(requestParameters: GetWorksAgreementHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getWorksAgreementHtml().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getWorksAgreementHtml().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/versions/{versionNumber}/works-agreement-html`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generates an HTML preview of the works agreement for a form version
     */
    async getWorksAgreementHtml(requestParameters: GetWorksAgreementHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getWorksAgreementHtmlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates the works agreement for a form version as a PDF
     */
    async getWorksAgreementPdfRaw(requestParameters: GetWorksAgreementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getWorksAgreementPdf().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling getWorksAgreementPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/versions/{versionNumber}/works-agreement-pdf`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Generates the works agreement for a form version as a PDF
     */
    async getWorksAgreementPdf(requestParameters: GetWorksAgreementPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getWorksAgreementPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restore a specific version
     */
    async restoreApplicationFormVersionRaw(requestParameters: RestoreApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling restoreApplicationFormVersion().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling restoreApplicationFormVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/versions/{versionNumber}/restore`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"versionNumber"}}`, encodeURIComponent(String(requestParameters['versionNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Restore a specific version
     */
    async restoreApplicationFormVersion(requestParameters: RestoreApplicationFormVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.restoreApplicationFormVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
